__turbopack_context__.v({
  "actions": "sheets-promo-module__Q78yOG__actions",
  "check": "sheets-promo-module__Q78yOG__check",
  "features": "sheets-promo-module__Q78yOG__features",
  "lead": "sheets-promo-module__Q78yOG__lead",
  "preview": "sheets-promo-module__Q78yOG__preview",
  "previewAbilities": "sheets-promo-module__Q78yOG__previewAbilities",
  "previewAbility": "sheets-promo-module__Q78yOG__previewAbility",
  "previewAbilityLabel": "sheets-promo-module__Q78yOG__previewAbilityLabel",
  "previewHeader": "sheets-promo-module__Q78yOG__previewHeader",
  "previewMeta": "sheets-promo-module__Q78yOG__previewMeta",
  "previewModifier": "sheets-promo-module__Q78yOG__previewModifier",
  "previewName": "sheets-promo-module__Q78yOG__previewName",
  "previewScore": "sheets-promo-module__Q78yOG__previewScore",
  "previewStats": "sheets-promo-module__Q78yOG__previewStats",
  "promo": "sheets-promo-module__Q78yOG__promo",
  "title": "sheets-promo-module__Q78yOG__title",
});
